export default __webpack_public_path__ + "0c4ae91bae23217d39c97c322a80e1fc.png";